import React from "react";
import Header from "../../UserManagement/Components/Header";

const RevenueMixTab = () => {
  return (
    <div>
      <div>
        <Header
          title={"Revenue Mix"}
          // subTitle={"Product revenue, platform fees, and commission tracking"}
        />
      </div>
    </div>
  );
};

export default RevenueMixTab;
